import { COMPONENT_TYPE } from 'common/constants';
import { UNIFORM_PROPS } from 'common/constants/component-props';
import { AnswerProgressType } from './constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const answerProgress = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.ANSWER_PROGRESS> =>
	createModel({
		type: COMPONENT_TYPE.ANSWER_PROGRESS,
		componentProps: {
			[UNIFORM_PROPS.answerProgressType]: AnswerProgressType.num,
			styles: {},
			other: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.ANSWER_PROGRESS>;
